import PatientDetailsContainer from "../../../Component/Patients/PatientDetails/PatientDetails"

const PatientDetails = () => {
  return (
    <div className='page-body'>
      <PatientDetailsContainer />
    </div>
  )
}

export default PatientDetails